import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './FrameInfo.scss';

import orderSlice, { getCurrentOrder } from '../../../../store/slices/order.slice';
import { getCart } from '../../../../store/slices/cart.slice';
import loadingSlice from '../../../../store/slices/loading.slice';

import useFrames from '../../../../utils/hooks/useFrames';

import { Button } from '../../../../components/ui';
import { useLocation } from 'react-router';

interface props {
  modelCode: any;
}

const FrameInfo: React.FC<props> = ({ modelCode }) => {
  const dispatch = useDispatch();
  const {
    order: { frame },
  } = useSelector(getCurrentOrder);
  const [imgSrc, setImgSrc] = useState(frame?.thumbnail ? frame.thumbnail : '');
  const { getFrameByCode } = useFrames();
  const { orders } = useSelector(getCart);

  const location = useLocation();
  const orderItemId = new URLSearchParams(location.search).get('orderId');

  useEffect(() => {
    dispatch(loadingSlice.actions.setLoading(true));
  }, []);

  useEffect(() => {
    // if frame state is removed
    if (frame === undefined && !orderItemId) {
      getFrameByCode(
        {
          onSuccess: data => {
            if (data.length > 0) {
              dispatch(orderSlice.actions.setFrame(data[0]));
            }
          },
          onError: err => {},
        },
        modelCode,
      );
    } else {
      if (orderItemId) {
        const order = { ...orders.find(o => o.id?.toString() == orderItemId.toString()) };
        dispatch(orderSlice.actions.setOrder(order));
        dispatch(orderSlice.actions.deletePrescription());
      }
    }
  }, [frame]);

  const changePreview = (event: React.MouseEvent, img: string) => {
    event.preventDefault();
    setImgSrc(img ? img : '');
  };

  return (
    <div className="eyeglasses-wrapper">
      {frame ? (
        <>
          <div className={'frame-block ' + frame.id}>
            <div className="frame-preview">
              <img src={imgSrc || frame.thumbnail} alt={frame.modelName}></img>
            </div>
            <div className="frame-thumbnail">
              <ul>
                {frame.previews.map((i: string, index) => (
                  <li key={`previews-${index}`} className={imgSrc === i ? 'active' : ''}>
                    <img alt="preview" src={i} onClick={e => changePreview(e, i)} key={i} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="frame-details">
            <h1 className="uppercase">{frame.modelName}</h1>
            <span className="price">{'$ ' + frame.price.toFixed(2)}</span>
            <div className="stars-review"></div>
            <div className="frame-description">
              <p>{frame.description}</p>
            </div>
            <Button
              className="button secondary-button inline"
              click={() => dispatch(orderSlice.actions.setStep(1))}
            >
              Choose your lenses
            </Button>
          </div>
        </>
      ) : (
        <div>Eyeglass</div>
      )}
    </div>
  );
};

export default FrameInfo;
